
















import Vue from 'vue';

import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import FilterSection from '@/components/filter/FilterSection.vue';
import { SchemeVersionDateRange } from '@/models';
import PSODatePicker from '../shared/dates/PSODatePicker.vue';

@Component({
  components: {
    FilterSection,
    PSODatePicker,
  },
})
export default class HistoricDateFilter extends Vue {
  @Getter('schemeVersionsFilters', { namespace: 'schemes' })
  private schemeVersionsFilters!: SchemeVersionDateRange;

  get fromStoreFrom() {
    return this.schemeVersionsFilters.from;
  }

  get fromStoreTo() {
    return this.schemeVersionsFilters.to;
  }

  public submitFrom({ from }): void {
    this.$emit('on-date-change', {
      from,
      to: this.fromStoreTo,
    });
  }

  public submitTo({ to }): void {
    this.$emit('on-date-change', {
      from: this.fromStoreFrom,
      to,
    });
  }
}
